export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl -translate-x-1/4 translate-y-1/3"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 高清流畅 · 免会员观看</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              58影院 - 全网电视剧免费在线观看平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mb-3">
              追剧不等待，全集一次看完
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mb-8">
              58影院专注电视剧免费在线观看，覆盖国产剧、韩剧、美剧、日剧、泰剧等热门分类，每日同步更新最新剧集。无需注册会员，无需缓冲等待，高清画质流畅播放，让您随时随地享受极致追剧体验。本周新上线古装悬疑大剧与都市情感力作，热门话题持续升温。
            </p>

            <div className="flex flex-wrap items-center gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">2000+</p>
                  <p className="text-xs text-foreground-500">部热播剧集</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">500万+</p>
                  <p className="text-xs text-foreground-500">追剧用户信赖</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-lg font-bold text-foreground-950 font-heading">每日更新</p>
                  <p className="text-xs text-foreground-500">同步最新剧集</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 border border-background-200/60 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apps-line"></i>
                浏览剧集分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-full aspect-[4/3] max-w-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20scene%20with%20a%20large%20floating%20screen%20displaying%20colorful%20abstract%20streaming%20visuals%20and%20film%20elements%2C%20cozy%20modern%20living%20room%20with%20warm%20golden%20ambient%20lighting%2C%20soft%20shadows%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20photography%20style%20with%20cinematic%20color%20grading%2C%20warm%20terracotta%20and%20cream%20tones%2C%20entertainment%20focused%20composition&width=1040&height=780&seq=hero-cinema-2026&orientation=landscape"
                alt="58影院 - 电视剧在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}